import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured product update</div>
            <Link to={"jmrv-update-2024"}>
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    Jun 9, 2025
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Canopy height map of Amazon forest now available on AWS Registry of Open Data.
                </div>
            </Link>

            <Link to="/news/amazon-canopy-height-map" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Learn More
                </div>
            </Link>
        </>
    );
}
